import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  font-size: 16px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  color: #6610f2;
  /* line-height: 16px; */
`;

export const Button = styled.button`
  background: none;
  display: flex;
  outline: none;
  border: none;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  width: 30px;
`;
